/* eslint-disable max-len */
import { Card, Grid } from '@material-ui/core';
import React, { useState } from 'react';

import { ACHIEVEMENT_TYPE, KEYS } from '../../../constants/enums';

import DanhSachThanhTichTable from '../../../containers/QCV/DanhSachThanhTich/DanhSachThanhTichTable';
import DanhSachThanhTichButton from '../../../containers/QCV/DanhSachThanhTich/DanhSachThanhTichButton';
import DanhSachThanhTichProfile from '../../../containers/QCV/DanhSachThanhTich/DanhSachThanhTichProfile';

// Thứ tự & tiêu đề ĐỒNG BỘ với 7 loại thành tích KHCN (mục A) của form Đăng ký
// hồ sơ / HoSoViewAdmin. QCV 2026: bài báo trong nước đã GỘP vào "tạp chí quốc
// tế, quốc gia" (mọi bài báo lưu filterType = INTERNATIONAL) nên không tách riêng.
const THANH_TICH_LIST = [
	{ key: ACHIEVEMENT_TYPE.SOLUTION, title: 'Bằng độc quyền sáng chế, giải pháp hữu ích thuộc lĩnh vực xét thưởng' },
	{ key: ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL, title: 'Bài báo khoa học đăng trên tạp chí quốc tế, quốc gia thuộc lĩnh vực xét thưởng' },
	{ key: ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT, title: 'Bài báo khoa học đăng trên hội thảo quốc tế thuộc lĩnh vực xét thưởng' },
	{ key: ACHIEVEMENT_TYPE.RESEARCH_PROJECT, title: 'Chương trình, dự án, đề tài nghiên cứu khoa học thuộc lĩnh vực xét thưởng' },
	{ key: ACHIEVEMENT_TYPE.MONOGRAPH, title: 'Sách chuyên khảo, giáo trình, chương sách thuộc lĩnh vực xét thưởng' },
	{ key: ACHIEVEMENT_TYPE.TECH_COMPANY, title: 'Có sản phẩm khoa học công nghệ được ứng dụng thuộc lĩnh vực xét thưởng' },
	{ key: ACHIEVEMENT_TYPE.REWARD, title: 'Giải thưởng, huy chương đã đạt được thuộc lĩnh vực xét thưởng' },
];

function DanhSachThanhTich() {
	const [value, setValue] = useState(THANH_TICH_LIST[0].key);

	const arrayPath = window.location.href.split('/');
	const formId = parseInt(arrayPath.slice(arrayPath.length -1));

	return (
    <Grid container spacing={2} style={{ marginTop: 32 }}>
      <Grid item xs={3}>
        <DanhSachThanhTichProfile formId={formId} />
      </Grid>
      <Grid item xs={9}>
        <Card style={{ padding: 8, minHeight: 'calc(100vh - 124px)' }}>
          <DanhSachThanhTichButton
            value={value}
            setValue={setValue}
            formId={formId}
            thanhTichList={THANH_TICH_LIST}
          />
          <DanhSachThanhTichTable value={value} formId={formId} />
        </Card>
      </Grid>
    </Grid>
	)
}

export default DanhSachThanhTich;
